import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ModalController } from '@ionic/angular/lazy';

import { SearchListComponent } from '@/app/app/modals/search-list/search-list.component';
import { AppNavigationService } from '@/app/app/services/app/app-navigation.service';
import { isNotNullOrEmpty } from '@/shared/lib/core/utils/data-validation.util';
import { CoreModule } from '@/shared/lib/modules/core.module';
import { DeploymentStore } from '@/shared/lib/stores/deployment.store';

@Component({
    selector: 'ods-single-select',
    imports: [CoreModule],
    templateUrl: './single-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
  })
export class SingleSelectComponent {
  deploymentStore = inject(DeploymentStore);
  modalController = inject(ModalController);
  appNavigation = inject(AppNavigationService);

  readonly isTenantSelection = input<boolean>(true);
  readonly hasOptions = computed(() =>
    ((this.isTenantSelection() ? this.deploymentStore.tenantList() : this.deploymentStore.deploymentList())?.length ?? 0) > 0);

  async openModal() {
    const modal = await this.modalController.create({
      component: SearchListComponent,
      canDismiss: true,
      componentProps: {
        isTenantSelection: this.isTenantSelection(),
      },
    });

    modal.onDidDismiss().then((data) => {
      if (data.role === 'confirm') {
        if (isNotNullOrEmpty(data?.data)) {
          const current = this.isTenantSelection() ? this.deploymentStore.selectedTenantId() : this.deploymentStore.selectedDeploymentId();
          if (this.isTenantSelection()) {
            this.deploymentStore.setTenant(data.data, false);
          } else {
            this.deploymentStore.setDeployment(data.data, false);
          }
          // Another tenant/deployment: close the pages (scans, results, ...) that belong to the previous one
          if (data.data !== current) {
            this.appNavigation.resetToHome();
          }
        }
      }
    });
    return await modal.present();
  }

  refreshData() {
    if (this.isTenantSelection()) {
      this.deploymentStore.loadTenantList(true);
    } else {
      this.deploymentStore.loadDeploymentList(true);
    }
  }

}
